<template>
  <div class="WysiwygCmp">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WysiwygCmp',
};
</script>

<style lang="scss" scoped>
.WysiwygCmp {
}
</style>
